var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "slider",
    {
      ref: "slider",
      attrs: { title: "Cancellations" },
      model: {
        value: _vm.sliderVisible,
        callback: function($$v) {
          _vm.sliderVisible = $$v
        },
        expression: "sliderVisible"
      }
    },
    [
      _c("cancellations", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dataLoaded,
            expression: "dataLoaded"
          }
        ],
        attrs: { items: _vm.cancellationData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16462e96", { render: render, staticRenderFns: staticRenderFns })
  }
}